export function localizedText(item, field, language = "en", fallback = "") {
  return item?.[`${field}_${language}`] || item?.[field] ||
    item?.[`${field}_${language === "hi" ? "en" : "hi"}`] || fallback;
}

export function localizeQuestion(question, language) {
  if (!question) return null;
  const raw = question.raw || {};
  return {
    ...question,
    isAnswered: Boolean(question.isAnswered || question.selectedOptionId),
    questionHtml: localizedText(raw, "question_name", language, question.questionHtml || question.question),
    questionStatementOne: localizedText(raw, "question_statement_one", language, question.questionStatementOne),
    questionStatementTwo: localizedText(raw, "question_statement_two", language, question.questionStatementTwo),
    options: (question.options || []).map((option, index) => ({
      ...option,
      label: localizedText(question.rawOptions?.[index] || raw.question_option?.[index], "option_name", language, option.label),
    })),
  };
}

export function resetQuestion(question) {
  return {
    ...question,
    isAnswered: false,
    selectedOptionId: null,
    isGuess: false,
    answeredCreatedAt: "",
    questionTime: 0,
    options: (question.options || []).map((option) => ({ ...option, isSelected: false, userSelectedOption: 0 })),
  };
}

export function paletteQuestions(payload = {}) {
  const rows = payload.questions || payload.question_list || payload.questions_list || payload.question_number_list || payload.data || [];
  return (Array.isArray(rows) ? rows : []).map((item, index) => {
    const serialNo = Number(item.question_index || item.question_number || item.count || index + 1);
    const answered = Number(item.is_question_answered ?? item.is_answered ?? item.question_answered ?? 0) === 1;
    const correctness = item.is_answer_correct;
    return {
      id: Number(item.question_id || item.id || 0) || `placeholder-${serialNo}`,
      serialNo,
      question: localizedText(item, "question_name", "en", item.question || `Question ${serialNo}`),
      isLocked: String(item.free_paid).toUpperCase() === "P" && Number(item.payment_status) !== 1,
      status: !answered ? "unsolved" : correctness === null || correctness === undefined ? "solved"
        : [1, "1", true, "Y"].includes(correctness) ? "correct" : "incorrect",
    };
  });
}

export function practiceFilters(flow) {
  const aliases = {
    languages: "language", question_types: "question_type", question_importance: "quest_importance",
    tags: "question_tags", text_pic_filter: "text_pic", free_paid_filter: "free_paid", guess_filters: "guess_filter",
  };
  const fields = ["batch_id", "custom_user_pref_lang", "search_term", "bookmark_status", "quest_importance",
    "text_pic", "free_paid", "question_level", "question_type", "question_tags", "solved_unsolved",
    "correct_incorrect", "guess_filter", "personal_notes", "report_status", "language"];
  const result = {};
  fields.forEach((key) => { if (flow[key] !== undefined) result[key] = flow[key]; });
  if (flow.listQueryState?.searchTerm?.trim()) result.search_term = flow.listQueryState.searchTerm.trim();
  Object.entries(flow.listQueryState?.appliedFilters || {}).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") result[aliases[key] || key] = value;
  });
  return { ...result, ...(flow.question_filters || {}) };
}
